import { capitalize } from 'lodash';
import { useRouter } from 'next/router';
import React from 'react';

import { BANNER_TYPES } from '@sravni/react-advertisement';
import { Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { AB_NAME } from '../../../../constants/sitesettings';
import { useDictionaries } from '../../../../hooks/news';
import { useWhitelabel } from '../../../../reducers/whitelabel';
import { ListContentLayout } from '../../../Layouts/ListContentLayout';
import { MaterialCard, TestsCard } from '../../../ListCards';
import { ListGrid } from '../../../ListGrid';
import { ReduxBanner } from '../../../ReduxBanner';
import { SpecialOffersBlock } from '../../../SpecialOffersBlock';
import { ListCard } from '../../components/ListCard';
import { Preloader } from '../../components/Preloader';
import { Trigger } from '../../components/Trigger';
import { createListRenderer } from '../../helpers/createListRenderer';
import { withListContainer, ListContainerProps } from '../../hoc/withListContainer';
import { ListContainer } from '../List';

import styles from './styles.module.scss';

const getHorizontalDirectionByNumber = (num: number) => {
  if (num !== 1 && (num / 4) % 2 !== 0) {
    return 'horizontal-reverse';
  } else {
    return 'horizontal';
  }
};

const TagListContainer: React.FC<ListContainerProps> = (props) => {
  const { list, tabsForSpecialOffers, handleShowAuthPopup, triggerRef, loading, createItemClickHandler } = props;
  const isMobile = useIsMobile();
  const isWhitelabel = useWhitelabel();
  const {
    asPath,
    query: { tag },
  } = useRouter();
  const { tags } = useDictionaries();

  const currentTag = tags.find((el) => el.alias === tag) || {};
  const isTest = tag === 'testy-i-igry';

  const bannerIndex = isTest ? 0 : 1;

  const banner = <ReduxBanner lazy={true} abName={AB_NAME} type={BANNER_TYPES.TGBM_7} />;
  const injectConfig = {
    [bannerIndex]: !isWhitelabel && banner && (
      <ListGrid.Cell type="full" className={'h-mt-24 h-mb-24'}>
        {banner}
      </ListGrid.Cell>
    ),
    5: !!tabsForSpecialOffers.length && (
      <ListGrid.Cell type="full">
        <SpecialOffersBlock tabs={tabsForSpecialOffers} className={'h-mt-24'} isMainPage />
      </ListGrid.Cell>
    ),
  };

  return (
    <ListContainer
      heading={
        <ListContentLayout.Heading as={Typography.Heading} level={2} className={styles.heading}>
          {capitalize(currentTag.name)}
        </ListContentLayout.Heading>
      }
      preloader={<Preloader color={isTest ? 'dark' : undefined} isLoading={loading} />}
      {...props}
    >
      <ListContentLayout.Content as={ListGrid}>
        {createListRenderer(
          list,
          (material, index) => {
            const elNumber = index + 1;
            const isFullCard =
              !isMobile && isTest && (elNumber === 1 || elNumber === 4 || (elNumber > 4 && elNumber % 3 === 1));
            return (
              <ListCard
                wrapper={ListGrid.Cell}
                index={index}
                material={material}
                // ** такой вид ключа очень важен для корректного отображения статей
                key={`${material.alias}-${material.id}-${index}-${asPath}`}
                handleShowAuthPopup={handleShowAuthPopup}
                titleTag={index === 0 ? 'h1' : 'h2'}
                direction={isFullCard ? getHorizontalDirectionByNumber(index + 1) : 'vertical'}
                card={isTest ? TestsCard : MaterialCard}
                as="article"
                type={isFullCard ? 'full' : 'default'}
                onClick={createItemClickHandler(index, material)}
              />
            );
          },
          injectConfig,
        )}
        <Trigger ref={triggerRef} />
      </ListContentLayout.Content>
    </ListContainer>
  );
};

export const TagList = withListContainer()(TagListContainer);
